import type { FC } from 'react';
import React, { useCallback, useState } from 'react';
import type { ConfigType } from 'dayjs';

import { formatRelativeDateTime } from '@motorway/mw-dealer-shared-components/utils';

import { useInterval } from 'Utilities/hooks/hooks';

import { getIntervalFrequency } from './BidCreatedAtTimer.helpers';

type BidCreatedAtTimerProps = { value: ConfigType };

const BidCreatedAtTimer: FC<BidCreatedAtTimerProps> = ({ value }) => {
	const [{ fromNow, isDynamic }, setState] = useState(formatRelativeDateTime(value));

	const updater = useCallback(() => {
		setState(formatRelativeDateTime(value));
	}, [value]);

	useInterval(updater, getIntervalFrequency(value), { runInterval: isDynamic });

	return <>{fromNow}</>;
};

export default BidCreatedAtTimer;
